module.exports = {
  chainWebpack: (config) => {
    config.plugin("html").tap((args) => {
      args[0].title = "Build App by A Point";
      return args;
    });
  },

  runtimeCompiler: true,

  pwa: {
    name: "Build App Maintenance by A Point",
    themeColor: "#277dbe",
    msTileColor: "#000000",
    appleMobileWebAppCapable: "yes",
    appleMobileWebAppStatusBarStyle: "default",

    manifestOptions: {
      orientation: "any",
      display: "standalone",
      short_name: "Build-App תחזוקה",
      background_color: "#fff",
    },

    workboxPluginMode: "InjectManifest",
    workboxOptions: {
      swSrc: "src/service-worker.js",
      exclude: [/index\.html$/, /\.map$/, /\.bak$/, /_redirects/],
    },
  },

  publicPath: "./",
  productionSourceMap: true,

  // lint on save is disabled because its annoying and not necessary
  lintOnSave: false,
};
